import { Plus } from "lucide-react";
import RoomCard from "./RoomCard";

function uid() {
  return Math.random().toString(36).slice(2, 10);
}

export default function Step2Rooms({ rooms, setRooms, finishes, modularMultiplier }) {
  const addRoom = () => {
    setRooms([
      ...rooms,
      { id: uid(), area_type: "Kitchen", description: "", measurements: [] },
    ]);
  };

  return (
    <div data-testid="step-2-rooms">
      <div className="mb-6">
        <div className="overline text-[#C5A880] mb-2">Step 02</div>
        <h1 className="text-3xl sm:text-4xl font-display font-bold leading-tight">
          Area & measurements
        </h1>
        <p className="text-white/50 mt-2 text-sm">
          Add each room, then capture length × height and finish.
        </p>
      </div>

      {rooms.map((room, i) => (
        <RoomCard
          key={room.id || `room-${i}`}
          room={room}
          finishes={finishes}
          index={i}
          canDelete={rooms.length > 1}
          modularMultiplier={modularMultiplier}
          onChange={(r) => {
            const arr = [...rooms];
            arr[i] = r;
            setRooms(arr);
          }}
          onDelete={() => {
            const arr = [...rooms];
            arr.splice(i, 1);
            setRooms(arr);
          }}
        />
      ))}

      <button
        type="button"
        onClick={addRoom}
        className="w-full mt-2 h-14 rounded-xl border border-dashed border-white/15 text-white/80 hover:bg-white/5 hover:border-[#C5A880]/40 hover:text-[#C5A880] flex items-center justify-center gap-2 font-medium transition"
        data-testid="add-room-button"
      >
        <Plus size={18} />
        Add Another Room
      </button>
    </div>
  );
}
